<template>
    <div class="search-results">
        <div class="row">
            <div :class="`col-md-${width}`">
                <div v-if="results" class="results-wrapper">
                    <div class="result-group" v-for="group in results" :key="group.name">
                        <div class="result-group-name">{{ group.name }}</div>
                        <ul class="results">
                            <li v-for="result in group.results" :key="result.id">
                                <a :href="result.link" v-html="highlight(result.name)"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  
  props: {
      results: {
          default: null
      },
      query: {
          default: null
      },
      width: {
          default: 6
      }
  },

  methods: {

      highlight(value) {
        return value.replace(new RegExp('(' + this.query + ')', "gi"), '<span class="hit">$1</span>');
      }

  }

}
</script>

